import { safeCardUrl } from './activityPageCards.mjs';

// 只改变展示顺序；领取、升级与原请求仍使用服务器原键。
export function euroModuleOrder(presentation, activityType = '') {
  if (!presentation) return ['TOP', 'QUIZ', 'BUFF'].map(key => ({ key, enabled: key !== 'BUFF' || activityType === 'BUFF_CARD' }));
  const modules = presentation.modules;
  if (!Array.isArray(modules) || modules.length !== 3 || new Set(modules.map(item => item?.key)).size !== 3 || modules.some(item => !['BUFF', 'QUIZ', 'TOP'].includes(item?.key) || typeof item.enabled !== 'boolean')) return [];
  return modules;
}

export function buffDisplayCards(cards, presentation) {
  if (!Array.isArray(cards)) return [];
  const order = new Map((presentation?.cards || []).map((item, index) => [item.key, index]));
  return cards.slice().sort((left, right) => (order.get(left.key) ?? cards.length) - (order.get(right.key) ?? cards.length));
}

export function euroCardDisplay(key, presentation) {
  return presentation?.cards?.find(card => card.key === key) || {};
}

export function euroPanelStyle(key, presentation) {
  const url = safeCardUrl(presentation?.panels?.find(panel => panel.key === key)?.backgroundImageUrl);
  return url ? { backgroundImage: `url(${JSON.stringify(url)})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {};
}

export function euroNavigationTarget(card, device) {
  const mobile = device === 'h5';
  const value = card?.linkValue;
  if (card?.linkKind === 'EXTERNAL') return /^https?:\/\//i.test(value || '') ? safeCardUrl(value) : '';
  if (card?.linkKind === 'INTERNAL') {
    const path = safeCardUrl(value);
    return path.startsWith('/') ? mobile && path.startsWith('/pages/') ? '/#' + path : path : '';
  }
  if (['ACTIVITY', 'VENUE'].includes(card?.linkKind)) {
    if (!/^[1-9]\d{0,18}$/.test(String(value || ''))) return '';
    if (card.linkKind === 'ACTIVITY') return mobile ? `/#/pages/activity-detail/index?id=${value}` : `/activity/${value}`;
    return mobile ? `/#/pages/game/index?venueId=${value}` : `/game/venue/${value}`;
  }
  const routes = mobile ? { HOME: '/#/pages/index/index', SUPPORT: '/#/pages/customer/index', DEPOSIT: '/#/pages/deposit/index', MEMBER: '/#/pages/mine/index', PROMOTIONS: '/#/pages/activity/index' } : { HOME: '/', SUPPORT: '/customer/main', DEPOSIT: '/mine/finance/deposit', MEMBER: '/member', PROMOTIONS: '/activity/discount' };
  return routes[card?.linkKind] || '';
}

export { safeCardUrl as euroAssetUrl };
